<template>
    <div class="wrapper">
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/bg32.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">
                        <h1 class="title">About Us</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="about-description text-center">
                <div class="features-3">
                    <div class="container">

                        <div class="row">
                            <div class="col-md-8 mr-auto ml-auto">
                                               <h1 class="title">Our Company </h1>
                                               <h3><span style='font-size : 23px'>The PAGARSTAR TECHNOLOGY SERVICE INC. is a financial technology
company focusing on online financial business and builds
economic infrastructure for the internet. To build a world-class
platform application and to connect to the Filipinos especially
the OFW anywhere around the world using our software
application to accept payments and manage their transactions
online.</span></h3>
                                    <br />
<h3 style='margin-top : 20px'>PTS was founded and established in the Philippines this year
2021 composed with an international team.
The company's official and registered address is located at
Regus 27th floor Tower 2, The Enterprise Center 6766 Ayala ave
corner Paseo De Roxas Makati.</h3>
                            </div>
                        </div>

                        <div style='margin-bottom: 15px' class="row">
                            <div class="col-md-8 mr-auto ml-auto">
                                <h1 class="title">Our Mission<span style='font-size : 23px'>- To provide and support OFW and their loved ones in managing
their needs:</span> </h1> 
<li class='bullet'>Establish and operate national systems for clearing, payments, and settlements</li>
<li class='bullet'>Facilitate the development of secure & trusted new payment methods and technologies worldwide; </li>
<li class='bullet'>Protect and increase shareholder's values</li>
<li class='bullet'>Establish as an organization of choice for the employees.</li>
                              <br />
                            </div>
                        </div>

  <div class="row">
                            <div class="col-md-8 mr-auto ml-auto">
                                               <h1 class="title">Vision- <span style='font-size : 23px'>To be a leading provider of electronic payment and settlement services and be the best financial services app for the Filipinos and OFW.</span></h1>
                                    <br />

                            </div>
                        </div>

<div class="row">
                            <div class="col-md-8 mr-auto ml-auto">
                                               <h1 class="title">Values- <span style='font-size : 23px'>PTS values are highest standards of ethics, integrity and
teamwork. PTS is committed towards its members, shareholders,
partners and employees.</span></h1>
                         
                            </div>
                        </div>
                          <h2 style='margin-top : 50px' class="title"> With our state of art infrastructure, we can handle up to
                         <div class="iCountUp">
                          
    <ICountUp
      :delay="delay"
      :endVal="endVal"
      :options="options"
      @ready="onReady"
    />
    </div>
      transaction DAILY!</h2>
  
 
                      
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, Badge, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'
 import ICountUp from 'vue-countup-v2';
  export default {
    name: 'about-us',
    bodyClass: 'about-us',
    components: {
       ICountUp, 
      Card,
      InfoSection,
      Badge,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
       methods: {
      onReady: function(instance, CountUp) {
        const that = this;
        
      }
    },
    data() {
      return {
          delay: 1000,
        endVal: 10000000,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        },
        form: {
          firstName: '',
          email: '',
          speciality: ''
        }
      }
    }
  }
</script>
<style>
.bullet{
  font-size: 20px;
}
.iCountUp {
    color:#007bff
  }
</style>
